import React from "react";
import BaseCard from "@/components/cards/BaseCard";

/**
 * ArticleCard — blog/insights card for /insights index and cross-links.
 * Props: { slug, title, dek?, image?, category?, readTime?, publishedAt? }
 */
const ArticleCard = ({ slug, title, dek, image, category, readTime, publishedAt }) => {
  const dateStr = publishedAt
    ? new Date(publishedAt).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;

  return (
    <BaseCard
      to={`/insights/${slug}`}
      variant={image ? "photo" : "flat"}
      image={image}
      eyebrow={category || "Insights"}
      title={title}
      blurb={dek}
      footer={
        (dateStr || readTime) && (
          <p className="text-[12px] text-[color:var(--lt-text-mute)]">
            {[dateStr, readTime].filter(Boolean).join(" · ")}
          </p>
        )
      }
      testid={`article-card-${slug}`}
    />
  );
};

export default ArticleCard;
